import { render, staticRenderFns } from "./AlbumCover.vue?vue&type=template&id=498ea829&"
import script from "./AlbumCover.vue?vue&type=script&lang=js&"
export * from "./AlbumCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports